import Footer from "./Footer";
import Header from "./Header";

function Terms() {
  return (
    <>
      <Header />

      <section className="bg-white">
        <div className="container py-5">
          <h1 className="display-5 font-bold mb-0 ls-sm">Terms and Conditions</h1>

          <p className="mb-0 lh-sm">
            Welcome to <strong>Gorishtey.com</strong> (“we”, “our”, “us”). By
            accessing or using our website and services, you agree to comply
            with and be bound by the following terms and conditions. Please read
            them carefully.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">1. Eligibility</h2>
          <p className="mb-0">
            You must be at least 18 years old to use our services. By using
            Gorishtey.com, you represent and warrant that you meet this age
            requirement and have the legal capacity to enter into these Terms.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">
            2. Account Registration
          </h2>
          <p className="mb-0">
            Users must create an account to access certain features of our
            services. You agree to provide accurate, current, and complete
            information during registration and to update it as necessary. You
            are responsible for maintaining the confidentiality of your account
            login credentials.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">
            3. Services Provided
          </h2>
          <p className="mb-0">
            Gorishtey.com provides matrimonial and matchmaking services. While
            we facilitate connections between users, we do not guarantee
            compatibility, success in relationships, or any marriage outcomes.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">4. User Conduct</h2>
          <p className="mb-0">
            You agree not to:
            <ul className="list-disc list-inside">
              <li>Provide false or misleading information.</li>
              <li>Harass, abuse, or harm other users.</li>
              <li>
                Use the services for unlawful purposes or in violation of any
                local laws.
              </li>
            </ul>
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">5. Privacy</h2>
          <p className="mb-0">
            Our{" "}
            <a href="/privacy-policy" className="text-blue-600 underline">
              Privacy Policy
            </a>{" "}
            governs the collection and use of your personal information. By
            using our services, you consent to the terms outlined in the Privacy
            Policy.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">
            6. Payment and Subscriptions
          </h2>
          <p className="mb-0">
            Certain features may require payment. All payments are
            non-refundable unless otherwise stated. You agree to pay all fees
            associated with your chosen subscription and to comply with the
            billing terms.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">7. Termination</h2>
          <p className="mb-0">
            We reserve the right to suspend or terminate your account for
            violations of these Terms or for any activity deemed harmful to the
            community. Users may also terminate their accounts at any time.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">
            8. Limitation of Liability
          </h2>
          <p className="mb-0">
            To the fullest extent permitted by law, Gorishtey.com will not be
            liable for any indirect, incidental, or consequential damages
            arising from the use or inability to use our services. Users use the
            platform at their own risk.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">9. Governing Law</h2>
          <p className="mb-0">
            These Terms are governed by and construed in accordance with the
            laws of the jurisdiction where Gorishtey.com operates. Any disputes
            arising shall be resolved exclusively in the courts of that
            jurisdiction.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">
            10. Changes to Terms
          </h2>
          <p className="mb-0">
            We reserve the right to update or modify these Terms at any time.
            The updated Terms will be posted on this page, and your continued
            use of our services constitutes acceptance of the changes.
          </p>

          <p className="mt-4 text-danger fst-italic fs-4">
            If you have any questions about these Terms, please contact us at{" "}
            <strong>support@gorishtey.com</strong>.
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Terms;
